import React, { Component } from 'react';

import './GetStartedButton.styles.scss';

class GetStartedButton extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const { isGetStartedFormVisible, showGetStartedForm } = this.props;

    if (!isGetStartedFormVisible) {
      showGetStartedForm();
    }
  }

  render() {
    const landing = this.props.landing === 'landing' ? 'get-started-btn--landing' : 'wide' ? 'wide' : null;
    return (
      <button className={`get-started-btn ${landing}`} type="button" onClick={this.handleClick}>
        Get started
      </button>
    );
  }
}

export default GetStartedButton;
